<template>
  <Accordion title="Dados da Movimentação">
    <div class="grid grid-cols-4 gap-5">
      <InputNumber :modelValue="localValue.id" disabled label="Código" v-if="localValue.id" />
      <Select :disabled="localValue.id" :items="filteredTypes" v-model="localValue.type" label="Tipo" required :error="localErrors.type" />
      <InputNumber :modelValue="localValue.idMaterialRequest" disabled label="Código da Requisição" v-if="localValue.type === 'request'" />
      <InputZoom
        clearable
        required
        :disabled="localValue.id"
        label="Local Origem"
        v-model="localValue.idOriginWarehouse"
        :error="localErrors.idOriginWarehouse || localErrors.sameWarehouse"
        v-model:complete-object="completeObject"
        database="warehouse"
        item-text="name"
        item-value="id"
        :filter="originWarehouseFilters"
        placeholder="Selecione o depósito" />

      <InputZoom
        clearable
        required
        v-model="localValue.idDestinationWarehouse"
        label="Local Destino"
        :disabled="!localValue.idOriginWarehouse || localValue.id"
        :error="localErrors.idDestinationWarehouse || localErrors.sameWarehouse"
        database="warehouse"
        item-text="name"
        item-value="id"
        v-model:complete-object="completeObject2"
        :filter="computedItemsFilters"
        placeholder="Selecione o depósito" />

      <InputDateTime v-model="localValue.date" disabled label="Data" :error="localErrors.date" required />

      <InputZoom
        label="Protocolo"
        clearable
        :disabled="localValue.id"
        v-model="localValue.orderProtocol"
        :error="localErrors.orderProtocol"
        database="os"
        item-value="protocolo"
        v-model:complete-object="completeProtocol"
        placeholder="Selecione o protocolo" />

      <InputZoom
        v-model="localValue.idConstructionProject"
        clearable
        :disabled="localValue.id"
        label="Obra"
        :error="localErrors.idConstructionProject"
        database="constructionProject"
        item-text="protocolo"
        item-value="id"
        placeholder="Selecione a obra" />

      <InputZoom v-model="localValue.idUser" clearable :disabled="localValue.id" label="Responsável" :error="localErrors.idUser" database="user" item-text="name" item-value="id" required placeholder="Selecione o responsável" />

      <TextArea class="col-span-4" v-model="localValue.description" label="Descrição" placeholder="Insira uma descrição" :error="localErrors.description" />
    </div>
  </Accordion>
</template>

<script setup>
import { computed, reactive, ref, watch, onMounted } from 'vue'
import { useFormat } from '@/composables/useFormat'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import moment from 'moment'

const store = useStore()
const user = computed(() => store.state.user)

const { formatDatetimeToTimezone } = useFormat()

const props = defineProps({
  modelValue: Object,
  error: Object,
})

const emits = defineEmits(['update:modelValue'])

const localValue = reactive(props.modelValue)
const localErrors = ref(props.error)
const completeObject = ref(null)
const completeObject2 = ref(null)
const completeProtocol = ref({})

// Módulo para Corrigir tipos
const allTypes = [
  { label: 'Fornecimento', value: 'outgoing' },
  { label: 'Transferência', value: 'transfer' },
  { label: 'Devolução', value: 'devolution' },
  { label: 'Devolução ao Fornecedor', value: 'supplierDevolution' },
  { label: 'Baixa', value: 'downward' },
]

const allowedTypesByWarehouse = {
  team: ['devolution', 'transfer', 'downward'],
  physic: ['outgoing', 'devolution', 'supplierDevolution', 'transfer'],
  vehicles: ['devolution', 'transfer', 'downward'],
}

const filteredTypes = computed(() => {
  if (!completeObject.value || !completeObject.value.type) {
    return allTypes
  }

  const warehouseType = completeObject.value.type
  const allowedValues = allowedTypesByWarehouse[warehouseType] || []

  return allTypes.filter((type) => allowedValues.includes(type.value))
})

watch(completeObject, (newWarehouse) => {
  if (newWarehouse && newWarehouse.type && localValue.type) {
    const allowedValues = allowedTypesByWarehouse[newWarehouse.type] || []
    if (!allowedValues.includes(localValue.type)) {
      localValue.type = null
    }
  }
})
// Módulo para Corrigir tipos

const originWarehouseFilters = [{ column: 'type', operator: '=', value: 'physic' }]

// Computeds
const computedItemsFilters = computed(() => {
  if (completeObject.value) {
    return [{ column: 'type', operator: '!=', value: 'physic' }]
  }
  return []
})
//  Watchers
watch(
  () => props.modelValue,
  (newValue) => {
    localValue.value = newValue
  },
)

watch(
  () => props.error,
  (newValue) => {
    localErrors.value = newValue
  },
)

// Desnecessário
// watch(
//   () => localValue.idOriginWarehouse,
//   (newValue) => {
//     if (!route.params.id) {
//       localValue.idDestinationWarehouse = null
//     }
//   },
//   { immediate: true }
// )

watch(localValue, (newValue) => {
  emits('update:modelValue', newValue)
})

// Hooks
onMounted(() => {
  // localValue.date = moment()
  localValue.idUser = user.value.id
})

watch(
  () => completeProtocol.value,
  (newValue) => {
    emits('update:selectedProtocol', newValue)
  },
  { deep: true },
)
</script>
